import { render } from "./indexClientComponent.vue?vue&type=template&id=2f77ecea"
import script from "./indexClientComponent.vue?vue&type=script&lang=js"
export * from "./indexClientComponent.vue?vue&type=script&lang=js"

import "./indexClientComponent.vue?vue&type=style&index=0&id=2f77ecea&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__